/**
 * Chat channel members class
 */
export default class {
  constructor (data) {
    this.id = data._id
    this.name = data.name
    this.username = data.username
    this.picture_profile = data.picture_profile
    this.roles = data.roles || []
  }

  contextMenus () {
    let menus = [
      { title: 'Kick', key: 'kick', icon: 'mdi-account-remove', color: 'default' }
    ]
    const addOwner = [
      { title: 'Add ownership', key: 'add_owner', icon: 'mdi-shield-plus', color: 'default' }
    ]
    const removeOwner = [
      { title: 'Remove ownership', key: 'remove_owner', icon: 'mdi-shield-remove', color: 'default' }
    ]
    if (this.isOwner()) {
      menus = menus.concat(removeOwner)
    } else if (this.isMember()) {
      menus = menus.concat(addOwner)
    }
    return menus
  }

  isOwner () {
    return this.roles.includes('owner')
  }

  isLeader () {
    return this.roles.includes('leader')
  }

  isModerator () {
    return this.roles.includes('moderator')
  }

  isMember () {
    return this.roles.includes('member')
  }

  rolesFlatten () {
    return this.roles.join(', ')
  }

  displayAction (currentUser, menuKey) {
    switch (menuKey) {
      case 'kick':
        return currentUser.username === this.username
      case 'add_owner':
        return currentUser.username === this.username
      case 'remove_owner':
        return currentUser.username === this.username
    }
  }
}
